const ContactIconSvg = ({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
}: {
  height?: any;
  width?: any;
  viewBox?: any;
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M9.62541 3.33341C10.2766 3.46046 10.875 3.77892 11.3441 4.24804C11.8132 4.71716 12.1317 5.31559 12.2587 5.96675M9.62541 0.666748C10.9783 0.817039 12.2398 1.42286 13.2029 2.38475C14.166 3.34664 14.7734 4.60742 14.9254 5.96008M14.2587 11.2801V13.2801C14.2595 13.4657 14.2215 13.6495 14.1471 13.8196C14.0727 13.9898 13.9636 14.1425 13.8268 14.268C13.69 14.3935 13.5285 14.4891 13.3526 14.5486C13.1767 14.608 12.9903 14.6301 12.8054 14.6134C10.754 14.3905 8.78341 13.6895 7.05208 12.5667C5.4413 11.5432 4.07564 10.1775 3.05208 8.56675C1.9254 6.82755 1.22424 4.84741 1.00541 2.78675C0.988751 2.60239 1.01066 2.41659 1.06974 2.24116C1.12883 2.06574 1.22379 1.90454 1.34859 1.76783C1.47339 1.63112 1.62528 1.52189 1.79461 1.4471C1.96393 1.3723 2.14697 1.33359 2.33208 1.33341H4.33208C4.65562 1.33023 4.96927 1.4448 5.21459 1.65577C5.4599 1.86674 5.62013 2.15971 5.66541 2.48008C5.74983 3.12013 5.90638 3.74857 6.13208 4.35341C6.22177 4.59203 6.24119 4.85136 6.18802 5.10067C6.13485 5.34998 6.01132 5.57882 5.83208 5.76008L4.98541 6.60675C5.93445 8.27578 7.31638 9.65771 8.98541 10.6067L9.83208 9.76008C10.0133 9.58084 10.2422 9.45731 10.4915 9.40414C10.7408 9.35097 11.0001 9.37039 11.2387 9.46008C11.8436 9.68578 12.472 9.84233 13.1121 9.92675C13.4359 9.97243 13.7317 10.1356 13.9431 10.3851C14.1545 10.6346 14.2669 10.9531 14.2587 11.2801Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default ContactIconSvg;
